export default __webpack_public_path__ + "dist/media/Expand.0f1997f6.svg";